import React from 'react';

const ContactPage = () => {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: `url('/images/contact-hero.jpg')` }}
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1>
            <p className="text-xl mb-8">
              We're here to help your business grow. Reach out to us today.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Contact Form */}
          <div className="lg:col-span-7">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden transform transition-all duration-300 hover:shadow-2xl">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white text-center">
                <h2 className="text-2xl font-bold">Send Us a Message</h2>
                <p className="mt-2">Fill out the form below and we'll get back to you as soon as possible.</p>
              </div>
              
              <div className="p-8">
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">First Name*</label>
                      <input 
                        type="text" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                        placeholder="Your first name"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">Last Name*</label>
                      <input 
                        type="text" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                        placeholder="Your last name"
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">Email Address*</label>
                      <input 
                        type="email" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                        placeholder="Your email address"
                        required
                      />
                    </div>
                    
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">Phone Number*</label>
                      <input 
                        type="tel" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                        placeholder="Your phone number"
                        required
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Company/Business Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your company name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Service of Interest*</label>
                    <select 
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      required
                    >
                      <option value="">Select a service</option>
                      <option value="web-development">Web Development</option>
                      <option value="social-media-marketing">Social Media Marketing</option>
                      <option value="graphic-designing">Graphic Designing</option>
                      <option value="seo-services">SEO Services</option>
                      <option value="whatsapp-marketing">WhatsApp Marketing</option>
                      <option value="advertisement">Advertisement</option>
                      <option value="google-my-business">Google My Business</option>
                      <option value="influencer-marketing">Influencer Marketing</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message*</label>
                    <textarea 
                      className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={5}
                      placeholder="Tell us about your project or requirements"
                      required
                    ></textarea>
                  </div>
                  
                  <div className="flex items-center">
                    <input 
                      type="checkbox" 
                      id="privacy-policy" 
                      className="h-4 w-4 text-zolo-blue focus:ring-zolo-blue border-gray-300 rounded"
                      required
                    />
                    <label htmlFor="privacy-policy" className="ml-2 block text-sm text-gray-700">
                      I agree to the privacy policy and consent to being contacted regarding my inquiry.
                    </label>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-gradient-to-r from-zolo-blue to-zolo-orange text-white font-bold py-3 px-6 rounded-md transition duration-300 hover:from-zolo-orange hover:to-zolo-blue transform hover:scale-105"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
          
          {/* Contact Information */}
          <div className="lg:col-span-5">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden mb-8 transform transition-all duration-300 hover:shadow-2xl">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold text-left">Get in Touch</h3>
              </div>
              
              <div className="p-6 space-y-6">
                {/* Phone */}
                <div className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition duration-300">
                  <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange rounded-full p-3 text-white mr-4 flex-shrink-0 shadow-md">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h4 className="font-bold text-lg text-gray-800">Phone</h4>
                    <a href="tel:+919993547121" className="text-zolo-blue hover:underline text-lg font-medium block">+91 9993547121</a>
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition duration-300">
                  <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange rounded-full p-3 text-white mr-4 flex-shrink-0 shadow-md">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h4 className="font-bold text-lg text-gray-800">Email</h4>
                    <a href="mailto:contact@zoloservice.com" className="text-zolo-blue hover:underline text-lg font-medium block">contact@zoloservice.com</a>
                  </div>
                </div>          
                
                {/* Office Address */}
                <div className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition duration-300">
                  <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange rounded-full p-3 text-white mr-4 flex-shrink-0 shadow-md">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h4 className="font-bold text-lg text-gray-800">Office Address</h4>
                    <address className="text-lg font-medium not-italic">
                      Chhindwara, Madhya Pradesh 480001, India
                    </address>
                  </div>
                </div>
                
                {/* Business Hours */}
                <div className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition duration-300">
                  <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange rounded-full p-3 text-white mr-4 flex-shrink-0 shadow-md">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h4 className="font-bold text-lg text-gray-800">Business Hours</h4>
                    <p className="text-lg font-medium">
                      Monday to Saturday: 10:00 AM - 7:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Map */}
            <div className="bg-white rounded-lg shadow-xl overflow-hidden transform transition-all duration-300 hover:shadow-2xl">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold text-left">Our Location</h3>
              </div>
              
              <div className="p-6">
                <div className="rounded-lg overflow-hidden shadow-md">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59220.21118038936!2d78.89862979725864!3d22.057490605654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd5fa3edb6a0d59%3A0xbf895bc2ce1f3a3c!2sChhindwara%2C%20Madhya%20Pradesh!5e0!3m2!1sen!2sin!4v1654321234567!5m2!1sen!2sin" 
                    width="100%" 
                    height="300" 
                    style={{ border: 0 }} 
                    allowFullScreen={true} 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="ZOLO Service Location"
                    className="rounded-lg"
                  ></iframe>
                </div>
                
                <div className="mt-4 flex justify-start">
                  <a 
                    href="https://goo.gl/maps/1234567890" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-gradient-to-r from-zolo-blue to-zolo-orange text-white px-4 py-2 rounded-full hover:from-zolo-orange hover:to-zolo-blue transition duration-300 transform hover:scale-105"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Get Directions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Social Media Connect Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-800">Connect With Us</h2>
            <p className="text-gray-600 mt-2">Follow us on social media for updates and promotions</p>
          </div>
          
          <div className="flex justify-center space-x-6">
            <a href="https://www.facebook.com/zolodigitaladvertising" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-zolo-blue to-zolo-orange text-white p-4 rounded-full shadow-lg transition duration-300 transform hover:scale-110">
              <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/zolodigital_chhindwara/" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-zolo-blue to-zolo-orange text-white p-4 rounded-full shadow-lg transition duration-300 transform hover:scale-110">
              <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.98-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
            <a href="https://www.youtube.com/@zolodigitaladvertising3845" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-zolo-blue to-zolo-orange text-white p-4 rounded-full shadow-lg transition duration-300 transform hover:scale-110">
              <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      {/* Contact CTA */}
      <div id="contact" className="bg-gradient-to-r from-zolo-blue to-zolo-orange py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <h2 className="text-3xl font-bold mb-6">Ready to Grow Your Business?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Contact us today to discuss how our digital marketing services can help your business reach new heights.
          </p>
          <a 
            href="tel:+919993547121"
            className="inline-block bg-white text-zolo-blue font-bold py-3 px-8 rounded-full shadow-lg hover:bg-gray-100 transition duration-300 transform hover:scale-105"
          >
            Call Us Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
